import React from 'react'
import { t } from 'ttag'
import styles from './Stats.module.scss'
import sum from 'assets/icons/sum.svg'
import watch from 'assets/icons/watch.svg'
import checkbox from 'assets/icons/checkbox.svg'
import cx from 'classnames'

export const Stats = ({ scores, isGreyBackground, candidates, single }) => {
  const getComparisonClass = id =>
    candidates.findIndex(cand => cand.id === id)
      ? styles.second
      : single
      ? undefined
      : styles.first

  const visibleScores = scores.filter(score => score.answers)

  return (
    <div className={styles.statsBox}>
      <div
        className={cx(styles.statsHeader, {
          [styles.greyBackground]: isGreyBackground,
        })}
      >{t`OVERVIEW`}</div>
      <div className={styles.statsItem}>
        <span className={styles.icon}>
          <img src={sum} alt="sum" />
        </span>
        <span className={styles.label}>{t`GMA Score`}:</span>
        {visibleScores.map(score => (
          <span
            key={score.score}
            className={cx(styles.value, getComparisonClass(score.id))}
          >
            {score.score}
          </span>
        ))}
      </div>
      <div className={styles.statsItem}>
        <span className={styles.icon}>
          <img src={watch} alt="watch" />
        </span>
        <span className={styles.label}>{t`Time spent`}:</span>
        {visibleScores.map(score => (
          <span
            key={score.id}
            className={cx(styles.value, getComparisonClass(score.id))}
          >
            {score.time} {t`minutes`}
          </span>
        ))}
      </div>
      <div className={styles.statsItem}>
        <span className={styles.icon}>
          <img src={checkbox} alt="checkbox" />
        </span>
        <span className={styles.label}>{t`Correct answers`}:</span>
        {visibleScores.map(score => (
          <span
            key={score.id}
            className={cx(styles.value, getComparisonClass(score.id))}
          >
            {score.answers}/{score.questions} {t`items`}
          </span>
        ))}
      </div>
    </div>
  )
}
